import React from "react";
import TrashMain from "./TrashMain";
export default function TrashPage() {
  return (
    <div className="typora-container">
      <TrashMain />
    </div>
  );
}
